/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, April 3rd 2022, 1:07:23 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APIMany2OneSelectFormInput, ConcreteAPIMany2OneSelectFormInputProps } from "ui-widgets";
import { Currency } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import PaidIcon from "@mui/icons-material/Paid";

export const CurrencyPickerInput = <T,>(props: ConcreteAPIMany2OneSelectFormInputProps<T, Currency>) => {
  return (
    <APIMany2OneSelectFormInput<T, Currency>
      label="Currency"
      itemIdProperty="code"
      getOptionLabel={(option) => `${option.name} (${option.code})`}
      loadingText="Loading Currencies"
      apiServicePath={APISERVICEPATHS.currencies}
      inputStartAdornment={<PaidIcon color="primary" />}
      {...props}
    />
  );
};
